import { InjectionToken } from "@angular/core"

export interface AsyncConfig {
    id: string
  }

export const ASYNC_CONFIG = new InjectionToken<AsyncConfig>('async_config')
